// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27ONs","left":"styles_left__3XtvM","desktopActions":"styles_desktopActions__3xAcm","title":"styles_title__2ADHA"};